import React from 'react';
import { GiftIcon } from 'lucide-react';
import { volumes } from '../data/volumes';
import { bonuses } from '../data/bonuses';
import { OfferBlock } from './OfferBlock';
export function WhatYouGet() {
  return <section id="volumes" aria-labelledby="volumes-heading" className="bg-navy-950" data-id="element-206" data-mp="l44qe5mde5m2">
      <div className="mx-auto max-w-content px-4 py-20 sm:px-6 lg:py-28" style={{
      paddingTop: "0px",
      paddingBottom: "0px"
    }} data-id="element-207" data-mp="q1wgqv7d9jo5">
        <div className="max-w-3xl" data-id="element-208" data-mp="1dsikiaac8hsc">
          
          <h2 id="volumes-heading" className="mt-4 font-display text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-[2.75rem]" style={{
          paddingTop: "12px",
          paddingBottom: "12px",
          marginTop: "15px",
          marginBottom: "15px"
        }} data-id="element-209" data-mp="1iqtx2ss0p6e9">
            দ্য আর্জেন্টাইন মাইন্ডসেট সিস্টেমে আপনি ঠিক কী কী পাচ্ছেন
          </h2>
          <p className="mt-4 text-lg text-white/70" data-id="element-210" data-mp="1wp1nsiygnbgz">
            ৬টি সম্পূর্ণ ভলিউম + ৫টি এক্সক্লুসিভ বোনাস + লাইফটাইম অ্যাক্সেস।
          </p>
        </div>

        <ol className="mt-8 divide-y divide-white/10 border-y border-white/10" data-id="element-211" data-mp="2vglst7svwn5n">
          {volumes.map(volume => <li key={volume.number} className="grid grid-cols-[3.25rem_1fr] items-center gap-x-4 gap-y-2 sm:grid-cols-[3.75rem_1fr] sm:gap-x-5 lg:grid-cols-[3.75rem_15rem_1fr]" style={{
          paddingTop: "10px",
          paddingBottom: "10px"
        }} data-id="element-212" data-mp="2qi28tcxuplfx">
              <img src={volume.cover} alt={`তোমো ${volume.number}-এর কভার: ${volume.title}`} width={240} height={300} loading="lazy" decoding="async" className="h-auto w-full rounded border border-white/15 object-cover shadow-[0_6px_18px_-10px_rgba(0,0,0,0.9)]" data-id="element-213" data-mp="3e5sft70po0x9" />
              <div data-id="element-214" data-mp="3o2exjmxqqbv2">
                <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-celeste-400" data-id="element-215" data-mp="3j5er3awzb73f">
                  তোমো {volume.number}
                </p>
                <h3 className="mt-0.5 font-display text-base font-extrabold leading-tight tracking-tight text-white sm:text-lg" data-id="element-216" data-mp="1tr052ydchybm">
                  {volume.title}
                </h3>
              </div>
              <p className="col-span-2 text-[13px] leading-snug text-white/70 lg:col-span-1" data-id="element-217" data-mp="2ehc7sjzodmg5">
                {volume.description}
              </p>
            </li>)}
        </ol>

        <OfferBlock id="price" className="mx-auto mt-10 max-w-3xl border-b border-white/10 pb-10" data-id="element-218" data-mp="2nffsje2u6f6w" />

        <div className="mt-10" data-id="element-219" data-mp="2sg3j5yn5ku0l">
          <div className="rounded-2xl border border-celeste-500/25 bg-navy-900 p-6 sm:p-8" style={{
          paddingTop: "0px",
          paddingBottom: "0px"
        }} data-id="element-220" data-mp="2sd7k26zkjzak">
            <p className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.22em] text-sun" data-id="element-221" data-mp="31efh6lqcmu32">
              <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-222" data-mp="367gwuvydqxnp" />
              আজ বিনামূল্যে পাচ্ছেন
            </p>
            <h3 className="mt-2 font-display text-xl font-extrabold tracking-tight text-white sm:text-2xl" data-id="element-223" data-mp="3b7minvhyxpxv">
              ৫টি এক্সক্লুসিভ বোনাস
            </h3>

            <ul className="mt-5 grid gap-4 sm:grid-cols-2" style={{
            paddingTop: "0px",
            paddingBottom: "0px"
          }} data-id="element-224" data-mp="3l4r5lxjn1pfq">
              {bonuses.map(bonus => <li key={bonus.number} className="flex gap-3" data-id="element-225" data-mp="14gzxw5micnwc">
                  <img src={bonus.cover} alt={`বোনাস ${bonus.number}-এর কভার: ${bonus.name}`} width={64} height={64} loading="lazy" decoding="async" className="h-16 w-16 shrink-0 rounded border border-white/15 object-cover" data-id="element-226" data-mp="14jvzq51h7wq2" />
                  <div className="min-w-0" data-id="element-227" data-mp="1s7nav5ba63pr">
                    <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-sun" data-id="element-228" data-mp="1s6knh7d62jel">
                      বোনাস {bonus.number}
                    </p>
                    <h4 className="mt-0.5 font-display text-[15px] font-extrabold leading-tight tracking-tight text-white" data-id="element-229" data-mp="1igix28xccowi">
                      {bonus.name}
                    </h4>
                    <p className="mt-1 text-[13px] leading-snug text-white/70" data-id="element-230" data-mp="2axbsxxu19pnp">
                      {bonus.description}
                    </p>
                    <p className="mt-0.5 text-[13px] text-celeste-300" data-id="element-231" data-mp="265bxoiowrkxg">{bonus.detail}</p>
                  </div>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}